import { render, staticRenderFns } from "./MailContactTypeForm.vue?vue&type=template&id=548fabcc&"
import script from "./MailContactTypeForm.vue?vue&type=script&lang=js&"
export * from "./MailContactTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./MailContactTypeForm.vue?vue&type=style&index=0&id=548fabcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports